import axios from 'axios';
import ViewUI from "view-design";
import Store from "../util/store";
import bus from "@/util/bus";


const target = process.env.npm_lifecycle_event;

let cancel,
  promiseArr = {};

let route = "";

if (process.env.NODE_ENV == "development") {
  // 测试
  //  route = `http://10.8.10.2:8989/`;
   route = `https://www.dceccn.com/apis`;
} else {
  //  测试服务器
  //route = `http://10.8.10.2:8989`;
  route = `https://www.dceccn.com/apis`;
  //测试

}


const CancelToken = axios.CancelToken;


axios.interceptors.request.use(config => {
  if (promiseArr[config.url]) {
    promiseArr[config.url]('操作取消')
    promiseArr[config.url] = cancel
  } else {
    promiseArr[config.url] = cancel
  }
  return config
}, err => {
  return Promise.reject(error)
})


axios.interceptors.response.use(response => {
  if (response.message === "登录已失效") {
    bus.$emit("showLogin", 1);
  }
  return response
}, err => {
  if (err && err.response) {
    switch (err.response.status) {
      case 400:
        err.message = '错误请求'
        break;
      case 401:
        err.message = '未授权，请重新登录'
        break;
      case 403:
        err.message = '拒绝访问'
        break;
      case 404:
        err.message = '请求错误,未找到该资源'
        break;
      case 405:
        err.message = '请求方法未允许'
        break;
      case 408:
        err.message = '请求超时'
        break;
      case 500:
        err.message = '服务器端出错'
        break;
      case 501:
        err.message = '网络未实现'
        break;
      case 502:
        err.message = '网络错误'
        break;
      case 503:
        err.message = '服务不可用'
        break;
      case 504:
        err.message = '网络超时'
        break;
      case 505:
        err.message = 'http版本不支持该请求'
        break;
      default:
        err.message = `连接错误${err.response.status}`
    }
  } else {
    err.message = "连接到服务器失败"
  }
  //message.err(err.message)
  return Promise.resolve(err.response)
})

//设置默认请求头
//可以自行设置其他的属性，例如授权，TOKEN等
axios.defaults.headers = {
  'X-Requested-With': 'XMLHttpRequest'
}
axios.defaults.timeout = 3600000

const axiosMethods = {

  get (url, param, showload) {
    if (url.indexOf("://") == -1) {
      let api = "/api/"
      let userinfo = Store.getters["sessions/getUserinfo"]

      if (axiosMethods.urlFilter(url) && userinfo.account) {
        api = api + "admin/"
      }
      url = route + api + url;
    }
    if (typeof param == "undefined") {
      param = null;
    }
    if (showload !== false || typeof showload == "undefined") {
      showload = true;
    }
    return new Promise((resolve, reject) => {
      if (showload) {
        ViewUI.Spin.show();
      }
      axios({
        method: "get",
        url: url,
        params: param,
        cancelToken: new CancelToken(c => {
          cancel = c;
        })
      })
        .then(res => {

          if (showload) {
            ViewUI.Spin.hide();
          }
          resolve(res.data);
        })
        .catch(err => {
          if (showload) {
            ViewUI.Spin.hide();
          }
          reject(err);
        });
    });
  },

  post (url, param, showload, config) {
    if (url.indexOf("://") == -1) {
      let api = "/api/"
      let userinfo = Store.getters["sessions/getUserinfo"]
      let ads = url == 'evaluate/queryDline' || url == 'evaluate/queryDlineWorks'
      if (axiosMethods.urlFilter(url) && userinfo.account && !ads) {
        api = api + "admin/"
      }
      url = route + api + url;
    }
    if (typeof param == "undefined") {
      param = null;
    }
    if (showload !== false || typeof showload == "undefined") {
      showload = true;
    }
    return new Promise((resolve, reject) => {
      if (showload) {
        ViewUI.Spin.show();
      }
      axios({
        method: "post",
        url: url,
        data: param,
        ...config,
        cancelToken: new CancelToken(c => {
          cancel = c;
        })
      })
        .then(res => {
          if (showload) {
            ViewUI.Spin.hide();
          }
          if (res !== undefined) {
            resolve(res.data);
          }
        })
        .catch(err => {
          if (showload) {
            ViewUI.Spin.hide();
          }
          reject(err);
        });
    });
  },


  all (params, showload) {
    if (showload !== false || typeof showload == "undefined") {
      showload = true;
    }
    let args = [];

    params.forEach(x => {
      let item = null,
        url = route + "/api/" + x.url;

      x.query = reconstruct(x.query);
      if (x.method == "get") {
        item = axios.get(url);
      } else {
        item = axios.post(url, x.query);
      }
      args.push(item);
    });

    return new Promise((resolve, reject) => {
      if (showload) {
        ViewUI.Spin.show();
      }
      axios
        .all(args)
        .then(
          axios.spread((...argument) => {
            let rets = [];
            for (let i of argument) {
              rets.push(i.data);
            }
            let obj = {};
            rets.forEach((x, i) => {
              obj[params[i].key] = x;
            });
            ViewUI.Spin.hide();
            resolve(obj);
          })
        )
        .catch(err => {
          ViewUI.Spin.hide();
          reject(err);
        });
    });
  },
  urlFilter (url) {
    let urlArray = ['userMange', 'teacherManage', 'studentManage', 'siteConfigure', 'serveManage', 'messageCenter', 'hiLookBackManage', 'fileManage', 'evaluateCenter', 'enlistManage', 'dashBoardManage', 'courseCenter', 'contentManage', 'auditCenter', 'activityCenter']
    let bool = false
    urlArray.forEach(value => {
      if (url.indexOf(value) !== -1) {
        bool = true
      }
    })
    return bool
  }
};

let reconstruct = (args) => {
  //Vuex处理Userinfo-获取
  let u = Store.getters["sessions/getUserinfo"];
  args = args ? args : {};
  if (u) {
    args.token = u.token;
    // args.creator = u.guid;
    // args.updator = u.guid;
  }
  return args;
}



export default {
  route: route,
  get: function (method, param, showload) {
    param = reconstruct(param);
    if (showload === false) {
      showload = false;
    }
    return axiosMethods.get(method, param, showload);
  },
  post: function (method, param, showload, config) {
    param = reconstruct(param);
    if (showload === false) {
      showload = false;
    }
    return axiosMethods.post(method, param, showload, config);
  },
  all: function (params, showload) {
    if (showload === false) {
      showload = false;
    }
    return axiosMethods.all(params, showload);
  }
};



// WEBPACK FOOTER //
// ./src/util/axios-config.js